export default "Samarbejd to og to om at lave flotte helfigurs aftegninger af hinanden og dekorer figurerne med naturmaterialer.";